export const getOrgRefId = issuer => {
  return issuer
    .split('-')
    .slice(2)
    .join('-');
};

export default getOrgRefId;
